import useCustomFunc from '@/composables/custom-func/custom-func';
import { walk } from 'shared/lib/walker/query-walker';

export function useGoalExclusionCheck() {
  const { hasAllEntriesForEntity } = useCustomFunc();

  const extractCustomFunctions = (queries) => {
    const customFunctions = [];

    walk(queries, 'children', (node) => {
      if (node.customFunc !== undefined && node.alias !== undefined) {
        customFunctions.push({
          alias: node.alias,
          customFunc: node.customFunc,
        });
      }
    });

    return customFunctions;
  };

  const shouldExclude = (entity, context) => {
    const { queries } = context;
    if (entity.completelyLoaded !== true) {
      return false;
    }

    const customFunctions = extractCustomFunctions(queries);
    if (customFunctions.length === 0) {
      return true;
    }

    const hasAllCustomFuncData = customFunctions.every((customFunc) => hasAllEntriesForEntity(entity, customFunc.customFunc.name, customFunc.alias, customFunc.customFunc?.args || []));

    return hasAllCustomFuncData;
  };

  return { shouldExclude };
}
